/**
 * 与项目 .postcssrc.js 中 postcss-pxtorem 的 rootValue 保持一致，
 * 使 JS 内联样式与 Vue 里经 postcss 转换的 rem 随 html 根字号同步缩放。
 * @see rem.js 动态设置 document.documentElement.style.fontSize
 */

export const POSTCSS_ROOT_VALUE = 46.875

/** 设计稿 px → rem 字符串，用于 DOM 内联样式（tooltip HTML 等） */
export function designPxToRem(px) {
  if (px == null || Number.isNaN(Number(px))) return '0rem'
  return `${Number(px) / POSTCSS_ROOT_VALUE}rem`
}

/**
 * 设计稿 px → 当前根字号下的实际 px 数值，用于 ECharts 画布 option（axisLabel.fontSize 等只认 px）
 */
export function designPxToRootPx(designPx) {
  if (typeof document === 'undefined') return Number(designPx)
  const root = parseFloat(getComputedStyle(document.documentElement).fontSize) || 32
  return (Number(designPx) / POSTCSS_ROOT_VALUE) * root
}
